import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TagTenantBridgeService {
  public shouldReloadTags = new Subject<boolean>();
  constructor() {}
}
